import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { provideToastr } from 'ngx-toastr'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideRouter } from '@angular/router'
import { routes } from './app/app.routes'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { TokenAccessInterceptor } from './app/interceptors/token-access.interceptor'
import { TokenRefreshInterceptor } from './app/interceptors/token-refresh.interceptor'
import { JwtModule } from '@auth0/angular-jwt'
import { importProvidersFrom, enableProdMode } from '@angular/core'
import { environment } from './environments/environment'
import { ErrorInterceptor } from './app/interceptors/error.interceptor'
import { LocalStorageService } from './app/services/local-storage/local-storage.service'
import { MatNativeDateModule } from '@angular/material/core'
import { TokenSession } from './app/models/users.interface'

if (environment.production) {
    enableProdMode()
}

export function tokenGetter() {
    const token = localStorage.getItem('token')
    const accesToken = token ? (JSON.parse(token) as TokenSession) : null
    return accesToken?.access ?? null
}

export const dualListSettings = {
    add: 'añadir',
    remove: 'quitar',
    all: 'todos',
    none: 'ninguno',
    direction: 'left-to-right',
    draggable: true,
    locale: 'es',
}

bootstrapApplication(AppComponent, {
    providers: [
        provideHttpClient(
            withInterceptors([
                TokenAccessInterceptor,
                TokenRefreshInterceptor,
                ErrorInterceptor,
            ])
        ),
        LocalStorageService,
        importProvidersFrom(
            JwtModule.forRoot({
                config: {
                    tokenGetter: tokenGetter,
                    allowedDomains: [environment.domain],
                    disallowedRoutes: [`${environment.domain}/login`],
                },
            }),
            MatNativeDateModule
        ),
        provideAnimations(),
        provideToastr({
            positionClass: 'toast-top-right',
            timeOut: 3000,
            closeButton: true,
            progressBar: true,
        }),
        provideRouter(routes),
        provideAnimationsAsync(),
    ],
})
